import { CheckoutContractAttributes } from '../global-checkout/checkout-contract-attribute.interface';
import { CheckoutContractsItemDetails } from './checkout-contract-item-details.interface';

export interface CheckoutContracts {
  contractAttributes: CheckoutContractAttributes;
  itemDetails: CheckoutContractsItemDetails;
}
